import {
  ApplicationConfig,
  inject,
  provideAppInitializer,
  provideBrowserGlobalErrorListeners,
  provideZoneChangeDetection,
} from '@angular/core'
import { provideRouter, withInMemoryScrolling } from '@angular/router'

import { routes } from './app.routes'
import { DateWeekDays, provideBricksUi } from '@enbw_bricks/ui'
import { provideHttpClient, withInterceptors } from '@angular/common/http'
import { authInterceptor } from './shared/auth/auth.interceptor'
import { AuthService } from './shared/auth/auth.service'

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes, withInMemoryScrolling({ scrollPositionRestoration: 'top' })),
    provideHttpClient(withInterceptors([authInterceptor])),
    provideBricksUi({
      locale: 'de-DE',
      datePickerOptions: {
        firstDayOfWeek: DateWeekDays.MONDAY,
      },
    }),
    provideAppInitializer(() => inject(AuthService).initializeAuth()),
  ],
}
